import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private apiUrl = environment.apiUrl; // Replace with your backend URL
  private userDataSubject = new BehaviorSubject<any | null>(null);
  userData$ = this.userDataSubject.asObservable();
  private roleaccessDataSubject = new BehaviorSubject<any | null>(null);
  roleaccessData$ = this.roleaccessDataSubject.asObservable();
  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<any> {
    const body = { username, password };
    return this.http.post<any>(this.apiUrl, body);
  }
  loginweb(postdata: any) {
    return this.http.post(environment.apiUrl + '/webuserlogin/webuserlogin', postdata);
  }
  loginwebSelectCompany(postdata: any) {
    return this.http.post(environment.apiUrl + '/logincompany/selectcompany', postdata);
  }
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userData'); // Clear user data
  }
  setToken(token: string): void {
    localStorage.setItem('token', token);
  }
  getCompanyInfo(): any | null {
    const data = localStorage.getItem('cmpinfo');
    return data ? JSON.parse(data) : null;
  }
  setCompanyInfo(cmpinfo: any): void {
    localStorage.setItem('cmpinfo', JSON.stringify(cmpinfo));
  }
  setCompanyList(cmplist: any): void {
    localStorage.setItem('cmplist', JSON.stringify(cmplist));
  }
  getCompanyList(): any | null {
    const data = localStorage.getItem('cmplist');
    return data ? JSON.parse(data) : null;
  }
  getToken(): string | null {
    return localStorage.getItem('token');
  }
  setUserData(userData: any): void {
    localStorage.setItem('userData', JSON.stringify(userData));
    this.userDataSubject.next(userData);
    this.checkorsetdate();
  }
  checkorsetdate() {
    localStorage.setItem('fdt', JSON.stringify(moment().startOf('month').format('YYYY-MM-DD')));
    localStorage.setItem('tdt', JSON.stringify(moment(new Date()).format('YYYY-MM-DD')));
  }
  getdate(key: any): any | null {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }
  setdate(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(moment(value).format('YYYY-MM-DD')));
  }
  useraccessget(postdata: any) {
    return this.http.post(environment.apiUrl + '/webuser/useraccess', postdata);
  }
  roleaccesset(val: any) {
    val.data[2].forEach((el: any) => {
      if (el.vview == 'true') {
        el.vview = true;
      } else {
        el.vview = false;
      }
    });
    localStorage.setItem('roleaccess', JSON.stringify(val.data[2]));
    this.roleaccessDataSubject.next(val.data[2]);
  }
  roleaccessget() {
    const data = localStorage.getItem('roleaccess');
    return data ? JSON.parse(data) : null;
  }
  getUserData(): any | null {
    const data = localStorage.getItem('userData');
    return data ? JSON.parse(data) : null;
  }

  isLoggedIn(): boolean {
    return this.getToken() !== null;
  }
  check() {
    return this.getToken() ? true : false;
  }
}
